import { render } from "./PopUpEditFolder.vue?vue&type=template&id=42e66d8c"
import script from "./PopUpEditFolder.vue?vue&type=script&lang=js"
export * from "./PopUpEditFolder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__